import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.tsx';

const PrivateRoute: React.FC = () => {
  const { status, session } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center" role="status">
        <Loader2 className="h-8 w-8 animate-spin text-sminy-primary" />
        <span className="sr-only">Validando sessão...</span>
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/" replace />;
  }
  if (session?.mustChangePassword && location.pathname !== '/primeiro-acesso') {
    return <Navigate to="/primeiro-acesso" replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
